import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import Icon from "@insite/mobius/Icon";
import Tooltip from "@insite/mobius/Tooltip";
import Typography from "@insite/mobius/Typography";
import advancedLine from "@sonic/Assets/Icons/advancedLine";
import basicLine from "@sonic/Assets/Icons/basicLine";
import expertLine from "@sonic/Assets/Icons/expertLine";
import interMediateLine from "@sonic/Assets/Icons/interMediateLine";
import { productSpecsStyle } from "@sonic/Widgets/ProductDetails/ProductFeaturesAndSpecs";
import { productLineDisplayStyle } from "@sonic/Widgets/ProductDetails/ProductLineDisplay";
import React from "react";
import { css } from "styled-components";

interface Props {
    product: ProductModel | undefined;
    variant?: string;
}
export const tooltipStyle = {
    tooltipWrapper: css`
        margin-left: auto;
        align-self: flex-start;
    `,
};

export const ProductLineDisplay: React.FC<Props> = ({ product, variant }) => {
    if (!product) {
        return null;
    }
    if (product.productLine === null) {
        return null;
    }
    const tooltipText = translate(
        "Expertise Level is an indicator of the necessary familiarity you should have with the subject matter (Basic, Beginner, Intermediate and Advanced)",
    );

    let iconLine = basicLine;
    switch (product.productLine.name) {
        case "Extreme": {
            iconLine = expertLine;
            break;
        }
        case "Advanced": {
            iconLine = advancedLine;
            break;
        }
        case "Intermediate": {
            iconLine = interMediateLine;
            break;
        }
        case "Basic": {
            iconLine = basicLine;
            break;
        }
        default:
            break;
    }

    if (variant === "card") {
        return (
            <StyledWrapper {...productLineDisplayStyle.smallContainer}>
                <Icon title={product.productLine.name} {...productLineDisplayStyle.icon} src={iconLine} />
            </StyledWrapper>
        );
    }

    if (variant === "card-right") {
        return (
            <StyledWrapper {...productLineDisplayStyle.smallContainer}>
                <Icon title={product.productLine.name} {...productLineDisplayStyle.iconRight} src={iconLine} />
            </StyledWrapper>
        );
    }

    if (variant === "small") {
        return (
            <StyledWrapper {...productLineDisplayStyle.smallContainer}>
                <Typography {...productSpecsStyle.attributeTypeValuesText}>{product.productLine.name}</Typography>
                <Icon {...productLineDisplayStyle.icon} src={iconLine} />
            </StyledWrapper>
        );
    }

    return (
        <StyledWrapper {...productLineDisplayStyle.container}>
            <Icon {...productLineDisplayStyle.icon} src={iconLine} />
            <Typography variant="headerSecondary">{product.productLine.name}</Typography>
            <Tooltip
                cssOverrides={{ tooltipWrapper: tooltipStyle.tooltipWrapper }}
                typographyProps={{ weight: 400 }}
                iconProps={{ color: "#DEDEDE" }}
                text={tooltipText}
            />
        </StyledWrapper>
    );
};
